<template>
    <div class="redTourism hml_whplt">
        <swiperList :swiperStyle="{padding: '1.29rem .4rem 0'}" :setSwiperNumFlag="true">
            <li
            class="redTourismSilde"
            v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
            :key="index"
            @click="redTourismSildeClick(index)"
            >
                <div class="leftImg">
                    <img :src="item.thumb">
                </div>
                <div class="rightText">
                    <h2>{{ item.title }}</h2>
                    <span>{{ item.keywords }}</span>
                    <p>{{ item.description }}</p>
                </div>
            </li>
        </swiperList>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {

        }
    },
    methods: {
        redTourismSildeClick(index){
            // console.log(index);
            this.setIndex({levelThreeIndex: index});
            this.$router.push("/panorama");
        },
        ...publicData.mapMutations(['setIndex'])
    },
    computed: {
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex"])
    }
}
</script>

<style lang="scss" scoped>
.redTourism{
    .redTourismSilde{
        width: 100%;
        height: 2.42rem;
        display: flex;
        align-items: center;
        .leftImg{
            width: 2.42rem;
            height: 2.23rem;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 2.26rem;
                height: 2.06rem;
            }
        }
        .rightText{
            width: 3.78rem;
            display: flex;
            flex-direction: column;
            margin-left: .3rem;
            h2{
                font-size: .4rem;
                color: #333;
                font-weight: bold;
                font-family: "siyuan";
            }
            span{
                color: #333;
                font-size: .24rem;
                margin-top: .14rem;
            }
            p{
                color: #999;
                font-size: .22rem;
                margin-top: .26rem;
                line-height: .33rem;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
        }
    }
}
</style>